import { SystemAlertModel } from '@/alert/entities/SystemAlert';
import CutwiseAPIClient, { METHOD_GET, METHOD_POST } from '@/common/network/CutwiseAPIClient';
import QueryResult from '@/common/network/QueryResult';

export const PATH_MY_ALERTS = 'api/alert/my';
export const PATH_READ_ALERT = 'api/alert/read';

export default class AlertAPI {
  getAlerts(): Promise<QueryResult<SystemAlertModel[]>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_MY_ALERTS);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  readAlert(id: string): Promise<QueryResult<never>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_POST).path(`${PATH_READ_ALERT}/${id}`);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
